import "./Dogs.module.css";
import Header from "@/reusable_sections/Header";
import IntroTopics from "./sections/IntroTopics";
import Questions from "./sections/Questions";
import Spotlight from "./sections/Spotlight";
import Footer from "@/reusable_sections/Footer";
export default function DogsPage() {
  return <div>
      <Header />
      <IntroTopics />
      <Questions />
      <Spotlight />
      <Footer />
    </div>;
}